import React, { useState } from "react";
import { Bell } from "lucide-react";
import { useAtom } from "jotai";
import { appConstants } from "../../atomstore/store";
import {
  isValidNotificationImageUrl,
  isValidNotificationUrl,
  openNotificationUrl,
  resolveNotificationUrl,
} from "../../utils/openNotificationLink";

const PushNotificationCard = ({ update }) => {
  const [constants] = useAtom(appConstants);
  const [imageError, setImageError] = useState(false);

  const imageUrl = isValidNotificationImageUrl(update?.image, constants)
    ? resolveNotificationUrl(update.image, constants)
    : null;
  const linkUrl = isValidNotificationUrl(update?.url, constants)
    ? update.url
    : null;
  const isClickable = !!linkUrl;

  const handleOpenLink = async (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    if (!linkUrl) return;
    await openNotificationUrl(linkUrl, constants);
  };

  const handleKeyDown = (event) => {
    if (!isClickable) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleOpenLink(event);
    }
  };

  return (
    <div
      className={`flex items-start space-x-3 ${isClickable ? "cursor-pointer" : ""}`}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onClick={isClickable ? handleOpenLink : undefined}
      onKeyDown={isClickable ? handleKeyDown : undefined}
    >
      <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 bg-gradient-to-br from-indigo-400 to-violet-600">
        <Bell className="w-5 h-5 text-white" />
      </div>
      <div className="flex-1 min-w-0 flex flex-col items-stretch">
        <div className="flex items-center space-x-2">
          <span className="text-sm text-gray-500 whitespace-nowrap flex-shrink-0">{update.time}</span>
          <span className="text-sm font-semibold text-gray-800 truncate">
            {update.type}
          </span>
        </div>
        {update.message ? (
          <p className="text-sm text-gray-600 mt-1">{update.message}</p>
        ) : null}
        {imageUrl && !imageError ? (
          <div className="mt-2 self-start w-full max-w-full sm:max-w-[280px] md:max-w-xs lg:max-w-sm overflow-hidden rounded-xl bg-gray-100 shadow-sm">
            <img
              src={imageUrl}
              alt={update.type || "Notification"}
              className={`block w-full h-auto max-h-40 sm:max-h-44 md:max-h-48 object-cover object-left ${
                isClickable ? "hover:opacity-95 transition-opacity" : ""
              }`}
              onError={() => setImageError(true)}
              onClick={isClickable ? handleOpenLink : undefined}
            />
          </div>
        ) : null}
        {isClickable ? (
          <p className="text-xs text-indigo-600 mt-2 font-medium text-left">
            Tap to open
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default PushNotificationCard;
